export const background = '#393E46'
export const backgroundDark = '#02101D'
export const primary = '#64FFDA'
export const hightlightBlue = '#64FFDA'
export const secondary = '#EEEEEE'
